export default "__VITE_ASSET__B938TXTl__"